import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['eventCount', 'readyAction', 'status', 'terminalAction']
  static values = {
    interval: { type: Number, default: 5000 },
    reload: { type: Boolean, default: false },
    url: String
  }

  connect () {
    this.active = true
    this.poll()
  }

  disconnect () {
    this.active = false
    window.clearTimeout(this.pollTimeout)
    this.abortController?.abort()
  }

  async poll () {
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`Status request failed with ${response.status}`)

      const report = await response.json()
      if (!this.active) return

      this.update(report)

      if (report.status === 'queued' || report.status === 'processing') {
        this.pollTimeout = window.setTimeout(() => this.poll(), this.intervalValue)
      } else if (this.reloadValue) {
        window.location.reload()
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.pollTimeout = window.setTimeout(() => this.poll(), this.intervalValue)
      }
    }
  }

  update (report) {
    if (this.hasStatusTarget) {
      this.statusTarget.className = `year-end-status year-end-status--${report.status}`
      this.statusTarget.textContent = this.statusLabel(report.status)
    }

    if (this.hasEventCountTarget && report.event_count != null) {
      this.eventCountTarget.textContent = report.event_count.toLocaleString()
    }

    this.readyActionTargets.forEach((action) => {
      const requiresPdf = action.dataset.requiresPdf === 'true'
      action.hidden = !report.ready || (requiresPdf && !report.pdf_ready)
    })

    const processing = report.status === 'queued' || report.status === 'processing'
    this.terminalActionTargets.forEach((action) => {
      action.hidden = processing
    })
  }

  statusLabel (status) {
    return status.charAt(0).toUpperCase() + status.slice(1)
  }
}
